import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import { FiGlobe, FiFileText, FiCheckCircle, FiExternalLink } from 'react-icons/fi';
import { motion } from 'framer-motion';

const Services = () => {
  const { t } = useLanguage();
  const portalUrl = "https://albertorodriguez.mytaxportal.online/";

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{t('services.title')}</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
          <p className="text-lg text-gray-600">{t('services.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Immigration Service Card */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl transition-all group"
          >
            <div className="h-3 bg-blue-600 group-hover:h-4 transition-all"></div>
            <div className="p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <SafeIcon icon={FiGlobe} className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('services.immigration.title')}</h3>
              <p className="text-gray-600 mb-6 min-h-[48px]">{t('services.immigration.desc')}</p>
              <ul className="space-y-3 mb-8">
                {t('services.immigration.items').map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
              <a href="#contact" className="inline-block text-blue-600 font-bold hover:text-blue-800 transition-colors">
                {t('hero.cta1')} →
              </a>
            </div>
          </motion.div>

          {/* Taxes Service Card */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl transition-all group"
          >
            <div className="h-3 bg-green-500 group-hover:h-4 transition-all"></div>
            <div className="p-8">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <SafeIcon icon={FiFileText} className="w-8 h-8 text-green-600" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('services.taxes.title')}</h3>
              <p className="text-gray-600 mb-6 min-h-[48px]">{t('services.taxes.desc')}</p>
              
              <ul className="space-y-3 mb-8">
                {t('services.taxes.items').map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
              
              <a 
                href={portalUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center space-x-2 py-4 bg-green-600 text-white rounded-xl font-bold hover:bg-green-700 transition-all shadow-lg group-hover:shadow-xl"
              >
                <span>{t('services.taxes.portalBtn')}</span>
                <SafeIcon icon={FiExternalLink} className="w-5 h-5" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;